<div class="flex flex-col gap-[24px]">
  <ng-container
    *ngIf="gatewayStatus$ | async | featureValue: 'online'; else disconnectedGatewayAlert"
  >
    <div class="content__header">
      <ng-container *ngIf="(devicesStore.isSelectedDeviceOBNG$ | async) === false">
        <div class="content-header__group" *ngIf="status$ | async | ready as status">
          <app-pill
            *ngIf="status?.properties?.active?.value"
            [type]="pillType.success"
            data-at-src-status-active
            >{{ '+INSTALLATIONS.SRC.ACTIVE.YES' | translate }}</app-pill
          >
          <app-pill
            *ngIf="!status?.properties?.active?.value"
            [type]="pillType.medium"
            data-at-src-status-active
            >{{ '+INSTALLATIONS.SRC.ACTIVE.NO' | translate }}</app-pill
          >
          <ng-container *ngIf="!(devicesStore.selectedDevice$ | async)?.isStandalone">
            <app-src-settings-activation
              [isInSettingsPage]="false"
              [gatewaySerial]="gatewaySerial"
            ></app-src-settings-activation>
          </ng-container>
        </div>
      </ng-container>
      <div *ngIf="remoteDeviceStore.isZigbeeTopologyAvailable$ | async" class="ml-auto">
        <span class="content-header__zigbee-topology-btn" (click)="openZigbeeTopologyDialog()">{{
          '+ZIGBEE_TOPOLOGY.OPEN_MODAL_TITLE' | translate
        }}</span>
      </div>
    </div>

    <app-jumbotron
      class="flex flex-row lt-md:flex-col gap-[16px] justify-between items-center lt-md:justify-start lt-md:items-start"
    >
      <div class="flex flex-col gap-[4px]" #widthIndicator>
        <h2>{{ '+INSTALLATIONS.SRC.VICARE_SMART_CLIMATE.TITLE' | translate }}</h2>
        <vi-text>{{ '+INSTALLATIONS.SRC.VICARE_SMART_CLIMATE.CONTENT' | translate }}</vi-text>
      </div>
      <div>
        <button
          class="btn-jumbotron"
          mat-button
          color="primary"
          gtm="onOpen"
          gtmAction="All added devices modal"
          gtmCategory="commissioning"
          [disabled]="(gatewayStore.devicesFlag$ | async).empty"
          (click)="openAllAddedDevicesDialog()"
        >
          <span
            >{{ '+COMMISSIONING.OVERVIEW.BUTTON.SHOW_ALL_DEVICES' | translate }} ({{
              commissioningService.getDevicesCount(gatewayStore.devices$ | async)
            }})</span
          >
          <mat-icon iconPositionEnd>chevron_right</mat-icon>
        </button>

        <button
          mat-raised-button
          class="btn-jumbotron"
          color="primary"
          (click)="openCommissioningOverlay()"
          [matBounceButton]="widthIndicator"
        >
          <mat-icon>add</mat-icon>
          <span>{{ '+INSTALLATIONS.SRC.VICARE_SMART_CLIMATE.BUTTON' | translate }}</span>
        </button>
      </div>
    </app-jumbotron>

    <div class="!hidden lt-md:!block"></div>

    <div
      *ngIf="
        (status$ | async | ready)?.properties?.active?.value === false &&
        commissioningService.getDevicesCount(gatewayStore.devices$ | async) < 1
      "
    >
      <app-banner
        *ngIf="devicesStore.getIsStoreAvailableForSrc$ | async"
        [title]="'+SRC_PANEL.NO_SRC_DEVICE_BANNER_HEADER' | translate"
        [link]="viessmannShop"
        [linkLabel]="'+INSTALLATIONS.INSTALLATION.PARTNERSHOP.STORE_LINK' | translate"
        linkGtm="onGoToShop"
        linkGtmAction="Buy SRC"
        linkGtmCategory="src"
        type="info"
      >
        {{ '+SRC_PANEL.NO_SRC_DEVICE_BANNER_BODY' | translate }}
      </app-banner>
    </div>

    <div *ngIf="devicesStore.getIsStoreAvailableForSrc$ | async">
      <app-banner
        *ngIf="gatewayStore.isLowZigbeeSignal$ | async"
        [link]="buyRepeaterLink"
        [linkLabel]="'+INSTALLATIONS.INSTALLATION.WIFI_SIGNAL_BANNER.STORE_LINK' | translate"
        linkGtm="onGoToShop"
        linkGtmAction="Buy repeater"
        linkGtmCategory="src"
      >
        {{ '+SRC_PANEL.LOW_CONNECTION_SIGNAL' | translate }}
      </app-banner>
    </div>

    <div class="flex justify-between items-center">
      <h2>{{ '+INSTALLATIONS.SRC.ALL_ROOMS' | translate }}</h2>
      <div class="flex items-center gap-[8px]">
        <ng-container *appHideForRsaUser>
          <button
            *ngIf="authStore.isCompanyFromGermany$ | async"
            data-at-create-vdz-form-btn
            mat-stroked-button
            (click)="createVdzForm()"
            class="vdz-form-btn-overlay"
            gtm="onCreateVdzForm"
            gtmAction="Create VdZ form"
            gtmCategory="srcDetails"
          >
            <mat-icon iconPositionStart>description</mat-icon>
            <span>{{ '+INSTALLATIONS.SRC.CREATE_VDZ_FORM' | translate }}</span>
          </button>
        </ng-container>
        <button
          data-at-open-src-settings-btn
          mat-stroked-button
          (click)="openSrcSettingsOverlay()"
          class="settings-btn-overlay"
          gtm="onOpenSrcSettingsOverlay"
          gtmAction="Installation details overlay"
          gtmCategory="installationDetails"
        >
          <mat-icon iconPositionStart>settings</mat-icon>
          <span>{{ '+INSTALLATIONS.SRC.SETTINGS' | translate }}</span>
        </button>
      </div>
    </div>

    <app-accordion *ngIf="rooms$ | async | ready as feature">
      <!-- Display rooms -->
      <ng-container *ngFor="let rId of feature | featureValue: 'enabled'">
        <ng-container *ngIf="rooms[rId] | async | ready as room">
          <app-accordion-item *ngIf="room.properties?.actors?.value?.length > 0">
            <app-accordion-title *ngIf="getRoom(rId) | async | ready as roomItem">
              <div class="flex flex-row gap-[4px] justify-start items-center">
                <div class="app-ellipsis">{{ roomItem | value2: featurePropertyKey.name }}</div>
                <app-room-warning [room]="roomItem" [roomId]="rId"></app-room-warning>
                <ng-container
                  *ngIf="getRoomOperatingStateModifier(rId) | async | ready as roomOperatingState"
                >
                  <app-pill
                    *ngIf="
                      roomOperatingState.properties?.modifier.value &&
                      roomOperatingState.properties?.modifier.value !==
                        RoomsOperatingStateModifier.none
                    "
                    [type]="pillType.error"
                    data-at-src-operating-status-modifier
                    >{{
                      roomOperatingState.properties?.modifier.value
                        | translateOperatingStateModifier
                    }}</app-pill
                  >
                </ng-container>
              </div>
            </app-accordion-title>
            <app-accordion-content>
              <app-room-panel [roomId]="rId"> </app-room-panel>
            </app-accordion-content>
          </app-accordion-item>
        </ng-container>
      </ng-container>

      <!-- Other rooms -->
      <ng-container *ngFor="let otherRoom of otherRooms$ | async; let i = index">
        <app-accordion-item *ngIf="(otherRoom | ready) && otherRoom?.properties?.active?.value">
          <app-accordion-title>
            <div class="app-ellipsis">
              {{ otherRoom | value2: 'name' || '+INSTALLATIONS.SRC.OTHER_ROOM.TITLE' | translate }}
            </div>
          </app-accordion-title>
          <app-accordion-content>
            <app-other-room-panel
              [otherRoom]="otherRoom"
              [otherRoomId]="i + ''"
            ></app-other-room-panel>
          </app-accordion-content>
        </app-accordion-item>
      </ng-container>

      <!-- Other unassignable devices -->
      <ng-container *ngIf="gatewayStore.unAssignableDevices$ | async as unAssignableGroupOfDevices">
        <app-accordion-item
          *ngIf="unAssignableGroupOfDevices && isAnyUnAssignableDevice(unAssignableGroupOfDevices)"
        >
          <app-accordion-title>
            <div>{{ '+INSTALLATIONS.SRC.OTHER_DEVICES.TITLE' | translate }}</div>
            <app-room-warning
              [isUnAssignablePanel]="true"
              [unassignableDeviceStatus]="unAssignableDeviceStatus$ | async"
            ></app-room-warning>
          </app-accordion-title>
          <app-accordion-content>
            <app-other-devices-panel
              [groupOfDevices]="unAssignableGroupOfDevices"
            ></app-other-devices-panel>
          </app-accordion-content>
        </app-accordion-item>
      </ng-container>
    </app-accordion>
  </ng-container>
</div>

<ng-template #disconnectedGatewayAlert>
  <app-banner>
    {{ '+INSTALLATIONS.INSTALLATION.INSTALLATION_STATUS.NO_RESPONSE' | translate }}
    <span data-at-last-res *ngIf="gatewayStatus$ | async as gatewayStatus">
      {{ '+INSTALLATIONS.INSTALLATION.INSTALLATION_STATUS.LAST_RESPONSE' | translate }}
      {{ gatewayStatus.timestamp | date: 'short' }}
    </span>
  </app-banner>
</ng-template>
